import { Link } from 'react-router-dom';

const steps = [
  {
    step: '01',
    title: 'Find Products',
    desc: 'Browse the kakobuy spreadsheet directory across 14 curated categories to discover products that match your style and budget.',
  },
  {
    step: '02',
    title: 'Compare Sellers',
    desc: 'Evaluate seller ratings, read buyer feedback, and compare prices to find the most reliable sources for your chosen items.',
  },
  {
    step: '03',
    title: 'Review QC Photos',
    desc: 'Check quality control photos and detailed product descriptions to ensure the items meet your expectations before purchasing.',
  },
  {
    step: '04',
    title: 'Select Shipping',
    desc: 'Choose the best shipping option for your location, considering delivery time, cost, and tracking availability.',
  },
  {
    step: '05',
    title: 'Order Safely',
    desc: 'Complete your purchase using secure payment methods and verified checkout processes for a worry-free buying experience.',
  },
];

export default function SafeBuyingSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Person%20sitting%20at%20modern%20desk%20with%20laptop%20open%20hands%20typing%20warm%20ambient%20lighting%20indoor%20plant%20on%20desk%20cozy%20home%20office%20setting%20window%20showing%20garden%20view%20calm%20focused%20atmosphere%20authentic%20lifestyle%20photography&width=900&height=675&seq=safe-v2-kkb-2026&orientation=landscape"
                alt="Safe buying process with Kakobuy Spreadsheet"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 text-xs font-semibold text-primary-700">
                Safe &amp; Verified Process
              </div>
            </div>
          </div>

          {/* Right: Steps */}
          <div className="w-full lg:w-1/2">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 tracking-tight mb-2">
              Safe Buying Process
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mb-8 leading-relaxed">
              Follow our proven 5-step process to shop confidently using kakobuy spreadsheet. We have helped thousands of buyers navigate the directory safely and successfully.
            </p>

            <div className="space-y-5">
              {steps.map((s) => (
                <div key={s.step} className="flex gap-4 group">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                    {s.step}
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-1">
                      {s.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <Link
                to="/guides/safe-kakobuy-spreadsheet-buying-tips"
                className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors"
              >
                <span>Read the full safety guide</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}